(() => {
  const init = () => {
    const btn = document.getElementById('BackToTop');
    if (!btn) return;

    const showAfter = 300;        // kdy se má ukázat
    const maxLiftDesktop = 260;   // max posun nahoru (desktop)
    const mobileMq = window.matchMedia('(max-width: 768px)');

    const target =
      document.querySelector('.email-signup') ||
      document.querySelector('.newsletter') ||
      document.querySelector('footer') ||
      document.querySelector('#shopify-section-footer') ||
      document.querySelector('.footer');

    let ticking = false;

    const update = () => {
      ticking = false;

      // 1) viditelnost
      btn.classList.toggle('is-visible', window.scrollY > showAfter);

      // 2) na mobilu NIKDY nezvedat
      if (mobileMq.matches) {
        btn.style.setProperty('--btt-footer-lift', '0px');
        return;
      }

      // 3) desktop: plynulé zvedání u footeru/newsletteru
      if (!target) return;

      const rect = target.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;

      const overlap = Math.max(0, vh - rect.top); // kolik px target leze do viewportu odspodu
      const lift = Math.min(maxLiftDesktop, overlap);

      btn.style.setProperty('--btt-footer-lift', `${lift}px`);
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    btn.addEventListener('click', () => {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();